module.exports = __webpack_public_path__ + "img/4-en.d4ecd28c.jpg";